import { useState } from "react";
import * as Scrivito from "scrivito";
import Carousel from "react-bootstrap/Carousel";
import { HeroSliderPanel } from "./HeroSliderPanel";
import { HeroSliderImage } from "./HeroSliderImage";

const HeroSliderWidget = ({ widget }) => {
  const panels = widget.get("panels");
  const [index, setIndex] = useState(0);
  const SLIDER_INTERVAL = 7000;
  const background = widget.get("background") || "blue";

  const shouldPause = Scrivito.isInPlaceEditingActive();

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const ImageCarousel = Scrivito.connect(() => (
    <Carousel
      activeIndex={index}
      onSelect={handleSelect}
      className="hero-slider-images"
      controls={false}
      indicators={false}
      pause="hover"
      interval={shouldPause ? null : SLIDER_INTERVAL}
      slide={true}
    >
      {panels.map((panel) => (
        <Carousel.Item key={panel.id()}>
          <HeroSliderImage panel={panel} />
        </Carousel.Item>
      ))}
    </Carousel>
  ));

  const PanelCarousel = Scrivito.connect(() => (
    <Carousel
      activeIndex={index}
      onSelect={handleSelect}
      className="hero-slider-panels"
      controls={false}
      indicators={true}
      pause="hover"
      interval={shouldPause ? null : SLIDER_INTERVAL}
      slide={true}
    >
      {panels.map((panel) => (
        <Carousel.Item text={panel.get("headline")} key={panel.id()}>
          <HeroSliderPanel panel={panel} slider={widget} />
        </Carousel.Item>
      ))}
    </Carousel>
  ));

  return (
    <div className="hero-slider">
      <ImageCarousel />
      <div className={`hero-slider-content --${background}`}>
        <div className="hero-slider-content-subheadline"></div>
        <div className="hero-slider-content-headline"></div>
        <div className="container-left-only">
          <div className="hero-slider-content-date"></div>
        </div>
      </div>
      <PanelCarousel />
    </div>
  );
};

Scrivito.provideComponent(
  "HeroSliderWidget",
  Scrivito.connect(HeroSliderWidget)
);

export default HeroSliderWidget;
